// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2DL3u","label":"CategoryService_label__2G7--","location":"CategoryService_location__3OYNv"};